var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcAvif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 471.3 500",
    style: {
      enableBackground: "new 0 0 471.3 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0B5953;}\n\t.st1{fill:#17BAB6;}\n\t.st2{fill:#FFFFFF;fill-opacity:0.4;}\n\t.st3{fill:#3DD3CC;}\n\t.st4{fill:#158983;}\n\t.st5{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,266.9 80.7,228.7 80.7,266.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "471.3,266.9 390.5,228.7 390.5,266.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.4,0.5l163,166v273.9c0,32.1-25.5,58.1-57,58.1H89c-31.5,0-57-26-57-58.1V58.6C32,26.5,57.5,0.5,89,0.5 H276.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M439.4,166.4H336.3c-31.5,0-59.9-28.9-59.9-61V0.5L439.4,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M169.7,218.3L169.7,218.3c0,5.7-4.6,10.4-10.4,10.4H98.6c-5.7,0-10.4-4.6-10.4-10.4l0,0 c0-5.7,4.6-10.4,10.4-10.4h60.7C165.1,207.9,169.7,212.6,169.7,218.3z M251.2,176.8L251.2,176.8c0,5.7-4.6,10.4-10.4,10.4H98.6 c-5.7,0-10.4-4.6-10.4-10.4l0,0c0-5.7,4.6-10.4,10.4-10.4h142.2C246.6,166.5,251.2,171.1,251.2,176.8z M251.2,135.3L251.2,135.3 c0,5.7-4.6,10.4-10.4,10.4H98.6c-5.7,0-10.4-4.6-10.4-10.4l0,0c0-5.7,4.6-10.4,10.4-10.4h142.2C246.6,125,251.2,129.6,251.2,135.3z  M251.2,93.8L251.2,93.8c0,5.7-4.6,10.4-10.4,10.4H98.6c-5.7,0-10.4-4.6-10.4-10.4l0,0c0-5.7,4.6-10.4,10.4-10.4h142.2 C246.6,83.4,251.2,88.1,251.2,93.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 266.9,
    className: "st4",
    width: 471.3,
    height: 156.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M149.4,368.8H121l-4.6,13.4H97.1l27.5-76.1h21.5l27.5,76.1H154L149.4,368.8z M135.2,326.6l-9.3,27.9h18.8 L135.2,326.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M244.3,306.1H264l-27,76.1h-23.2l-27-76.1h19.7l18.9,57.5L244.3,306.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M282.2,306.1h18.5v76.1h-18.5V306.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M324.7,306.1h49.6v14.9h-31v16h23.2v14.4h-23.2v30.8h-18.5V306.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcAvif);
export default __webpack_public_path__ + "static/media/ac_avif.1f952ffbb61c87482d546d67da35546f.svg";
export { ForwardRef as ReactComponent };